/**
 * @generated SignedSource<<f29757144342c690406c5958d85826e8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyerProductTile_item$data = {
  readonly productPhotos: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"ProductImage_photo">;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"ProductBaseTile_item" | "ProductImage_item">;
  readonly " $fragmentType": "BuyerProductTile_item";
};
export type BuyerProductTile_item$key = {
  readonly " $data"?: BuyerProductTile_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductTile_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isTrade"
    },
    {
      "defaultValue": "searchAndBrowse",
      "kind": "LocalArgument",
      "name": "pageDisplayEnum"
    },
    {
      "defaultValue": 1,
      "kind": "LocalArgument",
      "name": "photosLimit"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "priceBookName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "showSeller"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyerProductTile_item",
  "selections": [
    {
      "alias": "productPhotos",
      "args": [
        {
          "kind": "Variable",
          "name": "limit",
          "variableName": "photosLimit"
        }
      ],
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductImage_photo"
        }
      ],
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "pageDisplayEnum",
          "variableName": "pageDisplayEnum"
        },
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        },
        {
          "kind": "Variable",
          "name": "showSeller",
          "variableName": "showSeller"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ProductBaseTile_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductImage_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "ef796cb7ad94334288ba9cdd21a09617";

export default node;
